import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import Grid from "../../components/Grid";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { Show } from "../../hooks/Show";
import Select from "../../components/AppSelect";

const Area = ({
  reduxGetCities,
  cities,
  reduxGetAreas,
  areas,
  reduxGetArea,
  area,
  reduxPostArea,
  rowEdited,
  reduxDeleteArea,
  rowDeleted,
  reduxPatchArea,
  rowUpdated,
  reduxResetAreaForm,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    reduxResetAreaForm();
    setShow(false);
  };
  const handleShow = () => {
    reduxGetCities({
      page: 1,
      search: "",
      offset: 100000,
    });
    reduxResetAreaForm();
    reset();
    setShow(true);
  };
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData.idArea}</span>;
      },
      field: 'idArea',
      searchable: true
    },
    {
      title: "Descripción",
      render: (rowData) => {
        return <span>{rowData.description}</span>;
      },
      field: 'description',
      searchable: true
    },
    {
      title: "Ciudad",
      render: (rowData) => {
        return <span>{rowData.city.description}</span>;
      },
      field: 'city.description',
      searchable: true
    },
    {
      title: "Opciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-area">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-area">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-area">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];

  const handleOpen = (row) => {
    reduxGetCities({
      page: 1,
      search: "",
      offset: 100000,
    });
    reduxGetArea({
      id: row.idArea,
    });
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteArea(row);
    }
  };

  useEffect(() => {
    if (rowEdited && cities && Object.keys(cities).length > 0) {
      setShow(true);
      setValue("description", rowEdited.description);
      setValue("idCity", rowEdited.idCity);
    }
  }, [rowEdited, cities]);

  const handleDelete = (row) => {
    reduxDeleteArea(row);
  };

  useEffect(() => {
    reduxGetAreas({
      page: 1,
      offset: offset,
      search: "",
    });
  }, []);

  useEffect(() => {
    reduxGetAreas({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage]);

  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchArea({ ...data, id: rowEdited.idArea });
    } else {
      reduxPostArea(data);
    }
    reset();
    reduxResetAreaForm();
    setShow(false);
  };

  useEffect(() => {
    if (area || rowUpdated || rowDeleted) {
      reduxGetAreas({
        page: currentPage,
        offset: offset,
        search: search,
      });
      reduxResetAreaForm();
    }
  }, [area, rowUpdated, rowDeleted]);

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Áreas</h1>
                <Show when="feature:create-area">
                  <button
                    className="btn btn-primary btn-circle"
                    type="button"
                    onClick={handleShow}
                  >
                    <i className="fas fa-plus fa-sm"></i>
                  </button>
                </Show>
              </div>
              <p className="mb-4">Módulo de Administración de áreas</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Listado de Áreas
                  </h6>
                </div>
                <div className="card-body">
                  <Grid
                    cols={columns}
                    data={
                      areas && Object.keys(areas).length > 0 ? areas.items : []
                    }
                    page={
                      areas && Object.keys(areas).length > 0
                        ? Number(areas.page)
                        : currentPage
                    }
                    pages={
                      areas && Object.keys(areas).length > 0
                        ? Number(areas.totalPages)
                        : 0
                    }
                    total={
                      areas && areas.hasOwnProperty("total") ? areas.total : 0
                    }
                    offset={offset}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRange={(value) => {
                      setOffset(value);
                      reduxGetAreas({
                        page: 1,
                        offset: value,
                        search: search,
                      });
                    }}
                    defaultValue={search}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      reduxGetAreas({
                        page: 1,
                        offset: offset,
                        search: value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          onEscapeKeyDown={handleClose}
          backdrop="static"
          keyboard={true}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title>{rowEdited ? "Editar" : "Nuevo"} Área</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label htmlFor="description" className="form-label">
                  Descripción
                </label>
                <input
                  id="description"
                  type="text"
                  className={`form-control form-control-user ${
                    errors.description && "is-invalid"
                  }`}
                  {...register("description", { required: true })}
                />
                {errors.description && (
                  <span className="invalid-feedback">
                    La descripción es requerida
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="idCity" className="form-label">
                  Ciudad
                </label>
                <Select
                  isClearable={true}
                  {...register('idCity')}
                  id='idCity'
                  onChange={(value) => setValue('idCity', value?.value || '')}
                  options=
                  {cities &&
                    Object.keys(cities).length > 0 &&
                    cities.items
                      .map((ele) => ({                                    
                          value: ele.idCity,
                          label: ele.description,
                        }))
                  }
                />
                
                {errors.idCity && (
                  <span className="invalid-feedback">
                    La ciudad es requerida
                  </span>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Guardar
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cities: state.cityState.cities,
    areas: state.areaState.areas,
    area: state.areaState.area,
    rowEdited: state.areaState.rowEdited,
    rowDeleted: state.areaState.rowDeleted,
    rowUpdated: state.areaState.rowUpdated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCities: (payload) =>
      dispatch({
        type: "FETCH_CITIES_REQUEST",
        value: payload,
      }),
    reduxGetAreas: (payload) =>
      dispatch({
        type: "FETCH_AREAS_REQUEST",
        value: payload,
      }),
    reduxPostArea: (payload) =>
      dispatch({
        type: "CREATE_AREA_REQUEST",
        value: payload,
      }),
    reduxGetArea: (payload) =>
      dispatch({
        type: "READ_AREA_REQUEST",
        value: payload,
      }),
    reduxDeleteArea: (payload) =>
      dispatch({
        type: "DELETE_AREA_REQUEST",
        value: payload,
      }),
    reduxPatchArea: (payload) =>
      dispatch({
        type: "UPDATE_AREA_REQUEST",
        value: payload,
      }),
    reduxResetAreaForm: () =>
      dispatch({
        type: "RESET_AREA_FORM",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Area);
